var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"threeDimensional"},[(_vm.isShowBtn)?_c('back'):_vm._e(),_c('div',{staticClass:"content"},[_c('iframe',{attrs:{"src":_vm.src,"frameborder":"0"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }